/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upsell__Pls_Come_BackInputs */

const en_upsell__pls_come_back = /** @type {(inputs: Upsell__Pls_Come_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resubscribe now!`)
};

/**
* | output |
* | --- |
* | "Resubscribe now!" |
*
* @param {Upsell__Pls_Come_BackInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const upsell__pls_come_back = /** @type {((inputs?: Upsell__Pls_Come_BackInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upsell__Pls_Come_BackInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_upsell__pls_come_back(inputs)
});